import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'

// @ts-ignore
import config from '../web.config'

import { store } from './redux/configureStore'
import AppInitializer from './appInitializer'

import 'bootstrap/dist/css/bootstrap.min.css'
import './css/index.css'

const rootElement = document.getElementById('app')
const root = createRoot(rootElement!)

const hack = config // TODO: we need to figure out what this hack is used for

function Main() {
  return (
    <ReduxProvider store={store}>
      <AppInitializer />
    </ReduxProvider>
  )
}

root.render(<Main />)
